import React from 'react'
import {Link} from 'react-router-dom'
import {EMPLOYMENT} from 'procedureStatuses/reportList/common'
import ListGroup from 'jbc-front/components/ListGroup'

export const getReportList = function* ({employmentInsuranceJoined}) {
  if (employmentInsuranceJoined) {
    yield {
      num: 'r62',
      title: '雇用保険被保険者転勤届',
      editable: true,
      type: EMPLOYMENT,
    }
  }
}

const ProcedureInfo = ({procedureStatus}) => (
  <ListGroup>
    <ListGroup.Title>転勤情報</ListGroup.Title>
    <ListGroup.Item as={Link} to={`/change_office/update/${procedureStatus.id}`}>
      転勤情報編集
    </ListGroup.Item>
  </ListGroup>
)

export default {getReportList, ProcedureInfo}
